export enum FiUpgradeStatusType {
    Upcoming = 1,
    Completed = 2,
    Cancelled = 3,
}

export interface IUpgradesStatusType {
    Id: FiUpgradeStatusType;
    TextId: string;
}

export interface IUpgradeStatusData {
    Id: FiUpgradeStatusType;
    Name: string;
}

export const UpgradeStatusTypes: IUpgradesStatusType[] = [
    { Id: FiUpgradeStatusType.Upcoming, TextId: 'upgrade.upcoming' },
    { Id: FiUpgradeStatusType.Completed, TextId: 'common.completed' },
    { Id: FiUpgradeStatusType.Cancelled, TextId: 'common.cancelled' },
];
